import { BaseModal } from "./BaseModal";
import { LoginForm } from "./LoginForm";

interface ModalLoginProps {
	readonly show: boolean;
}
export function ModalLogin(props: ModalLoginProps) {
	return (
		<BaseModal show={props.show} close={null}>
			<div className="modal-body login" style={{ minWidth: "33vw", minHeight: "500px" }}>
				<div style={{ textAlign: "center", padding: "30px 20px" }}>
					<img src="/img/logoAlmacen.svg" style={{ width: "auto" }} height="80px" />
				</div>
				<div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
					<div style={{ flex: 0.25 }} />
					<div>
						<p style={{ textAlign: "center" }}> La sesión ha expirado. Por favor, inicie sesión nuevamente.</p>
						<LoginForm />
					</div>
					<div style={{ flex: 0.75 }} />
				</div>
			</div>
		</BaseModal>
	);
}